let hasWarnedIsolationBreach = false;

const warnIsolationBreach = () => {
  if (process.env.NODE_ENV !== "production" && !hasWarnedIsolationBreach) {
    hasWarnedIsolationBreach = true;
    console.warn("CRITICAL: White-label isolation breach detected.");
  }
};

export const assertRootDomainOnly = (isAgentPath) => {
  if (isAgentPath) {
    warnIsolationBreach();
    return false;
  }
  return true;
};

export const getRootOnlyClassName = (isAgentPath, className) => {
  if (isAgentPath && className) warnIsolationBreach();
  return isAgentPath ? "" : className;
};

export const getRootOnlyBoolean = (isAgentPath, value = true) => {
  if (isAgentPath && value) warnIsolationBreach();
  return !isAgentPath ? value : false;
};